// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"810ea194","486":"4c0a084b","592":"ffc7b842"}[chunkId] + ".chunk.js";
};